// GOV13 — the SINGLE interpretation of GET /api/v1/billing/me/entitlements, consumed by BOTH Billing.jsx and
// BusinessCommercial.jsx (Plan & Capabilities). No page-specific plan/limit normalization; the current plan is
// never inferred from the tier catalogue, target-plan cards, or tenant.tier_id.

// Normalize the canonical limits — a dict keyed by limit_key OR an array — into a stable array. Never invents
// values: a missing limit stays absent so the caller renders "Unavailable" (NEVER Unlimited or 0), and
// `unlimited` is true ONLY when the canonical value is explicitly -1.
export function normalizeLimits(entitlements) {
  const ld = entitlements?.limits_display;
  const arr = Array.isArray(ld)
    ? ld
    : (ld && typeof ld === 'object'
        ? Object.values(ld)
        : (Array.isArray(entitlements?.limits) ? entitlements.limits : []));
  return arr.map((l) => ({
    limit_key: l.limit_key,
    display_name: l.label || l.display_name || (l.limit_key || '').replace(/_/g, ' '),
    value: l.value,
    unlimited: l.value === -1,
    allowance_source: l.allowance_source || l.source_status || null,
    used: l.used,
    remaining: l.remaining,
  }));
}

// The canonical CURRENT plan — identity / version / status / price / cadence from entitlements ONLY. Returns
// null while entitlements are unloaded so the UI shows a loading/unavailable state, never a fallback plan.
export function selectCurrentPlan(entitlements) {
  const p = entitlements?.plan;
  if (!p) return null;
  const grandfathered = p.grandfathered != null ? !!p.grandfathered : (p.status_label === 'Grandfathered');
  return {
    plan_key: p.plan_id,
    display_name: p.plan_display_name || p.display_name || null,
    version: p.plan_version_label || p.version || null,
    grandfathered,
    status_label: p.status_label || (grandfathered ? 'Grandfathered' : 'Active'),
    price_cents: p.price_cents,
    currency: (p.price_book || p.currency || 'USD'),
    cadence: (p.billing_frequency || 'monthly'),
    raw: p,
  };
}

// Convenience: a display string for a limit value (canonical -1 → Unlimited; null/undefined → Unavailable).
export function limitValueLabel(l) {
  if (!l) return 'Unavailable';
  if (l.unlimited || l.value === -1) return 'Unlimited';
  if (l.value === null || l.value === undefined) return 'Unavailable';
  return String(l.value);
}
